<!--
오류정보 업데이트
------------------------------------
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-auto">

            <div class="uk-modal-header">
                <h4>오류내용 수정</h4>
            </div>
            <div class="uk-modal-body uk-padding-small">
                <app-error-type
                    class="uk-margin-small-bottom"
                    name="type"
                    :init-value="inputs.type"
                    @change="val => inputs.type = val"
                > </app-error-type>

                <app-input-ex
                    v-show="inputs.type === 22"
                    class="uk-margin-bottom"
                    type="text"
                    input-size="large"

                    name="arrival_amount"
                    v-model="inputs.arrival_amount"
                    label="실제도착수량"

                    required-layout="label-left"

                    placeholder="실제 도착한 수량을 정확히 입력하세요"
                > </app-input-ex>

                <app-error-return-label
                    class="uk-margin-small-bottom"
                    name="return_label"
                    :init-value="inputs.return_label"
                    @change="val => inputs.return_label = val"
                > </app-error-return-label>

                <app-input-ex
                    ref="memo"
                    class="uk-margin-small-bottom"
                    type="textarea"
                    input-size="small"
                    :textarea-rows="5"

                    name="request"
                    v-model="inputs.memo"
                    label="오류상세내용 (도착한 상품에 대한 설명)"

                    :validate-rules="{required: true}"
                    required
                    required-layout="label-left"

                    placeholder="오류내용을 구체적으로 작성하세요"
                > </app-input-ex>

            </div>


            <div class="uk-modal-footer uk-text-right">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    v-on:click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    저장
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // 입력값 object
                inputs: {
                    type: null,
                    return_label: null,
                    memo: null,
                    arrival_amount: null,
                },

                // 오류ID
                errorId: null,
            };
        },
        computed: {
        },
        methods: {
            /**
             * 입력폼 display
             */
            displayForm() {
                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param error_id 오류ID
             */
            form(error_id) {

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/errors/' + error_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    let error = response.error;

                    // id 저장
                    this.errorId = error.id;

                    // 입력값 설정
                    _.assignIn(this.inputs, {
                        type: error.type,
                        return_label: error.return_label,
                        memo: error.memo,
                        arrival_amount: error.arrival_amount,
                    });


                    // 폼띄우기
                    this.displayForm();
                });
            },

            /**
             * submit
             */
            submit() {
                // 오류상세내용 입력검증
                if ((this.inputs.type === 11 || this.inputs.type === 12 || this.inputs.type === 13)
                    && _.trim(this.inputs.memo) === ''
                ) {
                    alert('오류상세내용을 반드시 입력하세요');
                    this.$refs['memo'].inputFocus();
                    return;
                }

                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: '/errors/' + this.errorId,
                    data: _.merge({
                        '_token': this.csrfToken,
                    }, this.inputs),
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>